import { gql } from '@apollo/client';

export const GetMyMapFindsQueryName = 'GetMyMapFinds';

export const GET_MY_MAP_FINDS_QUERY = gql`
  query ${GetMyMapFindsQueryName}($filters: Filters) {
    getMyMapFinds(filters: $filters) {
      id
      createdBy
      description
      images
      foundAt
      material
      era
      type
      amcrId
      amcrData {
        images
      }
      latitude
      longitude
      draft
    }
  }
`;
